<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="43" height="43" rx="21.5" fill="white"/>
<rect x="0.5" y="0.5" width="43" height="43" rx="21.5" stroke="currentColor"/>
<g clip-path="url(#clip0_673_6342)">
<path d="M16.9996 16.9996H17.0079M16.9996 27.0004H17.0079M15.3328 13.666H28.6672C29.5878 13.666 30.334 14.4123 30.334 15.3328V18.6664C30.334 19.587 29.5878 20.3332 28.6672 20.3332H15.3328C14.4123 20.3332 13.666 19.587 13.666 18.6664V15.3328C13.666 14.4123 14.4123 13.666 15.3328 13.666ZM15.3328 23.6668H28.6672C29.5878 23.6668 30.334 24.4131 30.334 25.3336V28.6672C30.334 29.5878 29.5878 30.334 28.6672 30.334H15.3328C14.4123 30.334 13.666 29.5878 13.666 28.6672V25.3336C13.666 24.4131 14.4123 23.6668 15.3328 23.6668Z" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_673_6342">
<rect width="20" height="20" fill="white" transform="translate(12 12)"/>
</clipPath>
</defs>
</svg>
